import { useLoginForm } from '../../../hooks/auth/useLoginForm';
import { useLoginManager } from '../../../hooks/auth/useLoginManager';
import { LoginForm } from '../../organisms/authentication/LoginForm';


export const LoginManager = () => {
  const { handleSubmit, register, isSubmitting, errors } = useLoginForm();
  const onSubmit = useLoginManager();
  return <LoginForm onSubmit={handleSubmit(onSubmit)} register={register} errors={errors} isSubmitting={isSubmitting} title="マネジャーログイン" btnColor="teal" />
};